<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12">
            <div class="loader-wrapper">
                <div class="loader-text">
                    <h3><i class="fa fa-fw fa-circle-notch fa-spin fa-3x"></i></h3>
                    <h3>{{ label }}</h3>
                </div>        
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RoutingLoading",

    props: {
        label: {
            type: String,
            require: true,
        },
    },
}
</script>

<style scoped>
.loader-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  margin: auto;
  width: calc(100vw - 285px);
  height: 100vh;  
  background: rgb(0, 0, 0, 0.8);
  z-index: 9999;  
  overflow: hidden;
}

.loader-text {
    position: absolute;
    margin: auto;
    top: 30%;
    width: 100%;
    height: 100%;
    font-size: 30px;
    color: white;
    text-align: center;
}
</style>